import { render, staticRenderFns } from "./expertmenuForm.vue?vue&type=template&id=af91648e&scoped=true&"
import script from "./expertmenuForm.vue?vue&type=script&lang=js&"
export * from "./expertmenuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af91648e",
  null
  
)

export default component.exports